import { Injectable, inject, signal } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ProductCatalogApiService } from '../api/product-catalog-api.service';
import { categoriasDelCatalogo, productosDelCatalogo } from '../api/product-catalog.mapper';
import { CategoriaDescuento, ProductoCupon } from '../models/promociones.model';

@Injectable({ providedIn: 'root' })
export class CatalogoProductosService {
  private readonly api = inject(ProductCatalogApiService);

  private readonly _productos = signal<ProductoCupon[]>([]);
  readonly productos = this._productos.asReadonly();

  private readonly _categorias = signal<CategoriaDescuento[]>([]);
  readonly categorias = this._categorias.asReadonly();

  constructor() {
    this.cargar();
  }

  cargar(): void {
    forkJoin({
      productos: this.api.listarProductos(),
      presentaciones: this.api.listarPresentaciones(),
      categorias: this.api.listarCategorias(),
    }).subscribe({
      next: ({ productos, presentaciones, categorias }) => {
        this._productos.set(productosDelCatalogo(productos, presentaciones));
        this._categorias.set(categoriasDelCatalogo(categorias, productos));
      },
      error: (error) =>
        console.error('[Promociones] No se pudo cargar el catalogo de productos', error),
    });
  }
}
